import ComplaintTypeDTO from "features/requirements/dtos/ComplaintTypeDTO";
import FormGroup from "features/shared/forms/components/FormGroup";
import { Nullable } from "features/shared/types/nullable";
import React from "react";
import Select from "react-select";
import reactSelectStyles from "features/shared/components/reactSelect/reactselectcustom.module.scss";
import { useTranslation } from "react-i18next";

interface Props<T> {
  name: string;
  label: string;
  options: T[];
  optionName: string;
  optionValue: string;
  onChange: (type: Nullable<T>) => void;
  selectedValue?: Nullable<T>;
  placeholder?: string;
  errors?: Record<string, string>;
  searchable?: boolean;
  editable?: boolean;
}

const ComplaintSelect = <T extends object>({
  name,
  label,
  options,
  optionName,
  optionValue,
  onChange,
  selectedValue,
  placeholder,
  errors,
  searchable = false,
  editable = true
}: Props<T>) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (editable) {
    return (
      <FormGroup
        labelText={label}
        validationError={errors ? errors[name] : undefined}
      >
        <Select
          options={options}
          getOptionValue={(opt) => String((opt as any)[optionValue])}
          getOptionLabel={(opt) => String((opt as any)[optionName])}
          onChange={(val) => onChange(val)}
          value={selectedValue}
          captureMenuScroll={false}
          className={reactSelectStyles.customSelect}
          classNamePrefix="customSelect"
          isSearchable={searchable}
          placeholder={placeholder}
          noOptionsMessage={() => tLabels("complaintSelect.noOptionsMessage")}
        />
      </FormGroup>
    );
  } else {
    return null;
  }
};

export default ComplaintSelect;
